import { useMutation } from '@tanstack/react-query';

import { fetchListThreeApi } from '../api';

export default function useListThreeMutation(options?: any) {
  return useMutation(fetchListThreeApi, options);
}
